import { render, staticRenderFns } from "./frames.vue?vue&type=template&id=5de5c062"
import script from "./frames.vue?vue&type=script&lang=js"
export * from "./frames.vue?vue&type=script&lang=js"
import style0 from "./frames.vue?vue&type=style&index=0&id=5de5c062&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports